import { Flex, Text } from "@chakra-ui/react";
import GamelightButton from "components/button";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

interface PaginationProps {
  currentPage: number;
  onPageChange: (page: number) => void;
  hasNextPage: boolean;
}

const PartnerNotificationPagination: React.FC<PaginationProps> = ({
  currentPage,
  onPageChange,
  hasNextPage,
}) => {
  return (
    <Flex justify="center" gap={4} mt={4}>
      <GamelightButton
        onClick={() => onPageChange(currentPage - 1)}
        isDisabled={currentPage === 1}
        width="40px"
      >
        <FaAngleLeft />
      </GamelightButton>
      <Text alignSelf="center" fontWeight="bold">
        {currentPage}
      </Text>
      <GamelightButton
        onClick={() => onPageChange(currentPage + 1)}
        width="40px"
        isDisabled={!hasNextPage}
      >
        <FaAngleRight />
      </GamelightButton>
    </Flex>
  );
};

export default PartnerNotificationPagination;
